/**
 * OT Shopify Theme — Main JavaScript
 * Handles: navigation, cart drawer, gallery, accordions, scroll effects
 */

(function () {
  'use strict';

  /* ── Utility ── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ────────────────────────────────────────────
     SCROLL: sticky header shadow
  ──────────────────────────────────────────── */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ────────────────────────────────────────────
     MOBILE MENU
  ──────────────────────────────────────────── */
  const mobileToggle = $('.mobile-menu-toggle');
  const mobileMenu   = $('.mobile-menu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (mobileMenu.classList.contains('is-open') &&
          !mobileMenu.contains(e.target) &&
          !mobileToggle.contains(e.target)) {
        mobileMenu.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ────────────────────────────────────────────
     CART DRAWER
  ──────────────────────────────────────────── */
  const cartDrawer  = $('#cart-drawer');
  const cartOverlay = cartDrawer && $('.cart-drawer__overlay', cartDrawer);
  const cartClose   = cartDrawer && $('.cart-drawer__close', cartDrawer);

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Move focus inside
    const firstFocusable = cartDrawer.querySelector('button, a, input');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // Delegate cart-trigger clicks
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cart-trigger]');
    if (trigger) {
      e.preventDefault();
      openCart();
    }
  });

  /* ── Fetch and render cart ── */
  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawerItems(cart);
      })
      .catch(console.error);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  function renderCartDrawerItems(cart) {
    const body = $('#cart-drawer-body');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Nothing here yet — start exploring.</p>';
      return;
    }

    const html = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">
          ${item.image
            ? `<img src="${sizedImage(item.image, '_200x200')}" alt="${item.title}" loading="lazy">`
            : '<div style="background:var(--ot-line);width:100%;height:100%"></div>'}
        </div>
        <div class="cart-item__info">
          <p class="cart-item__title">${item.product_title}</p>
          ${item.variant_title ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <p class="cart-item__variant">Qty: ${item.quantity}</p>
          <button class="cart-item__remove" data-remove="${item.key}" aria-label="Remove ${item.title}">Remove</button>
        </div>
        <p class="cart-item__price">${formatMoney(item.line_price)}</p>
      </div>
    `).join('');

    const subtotal = `
      <div style="border-top: 1px solid var(--color-border-subtle); margin-top: var(--space-4); padding-top: var(--space-4);">
        <div style="display: flex; justify-content: space-between; font-weight: 500; margin-bottom: var(--space-2);">
          <span>Subtotal</span>
          <span>${formatMoney(cart.total_price)}</span>
        </div>
        <p style="font-size: 0.8125rem; color: var(--color-text-muted); margin-bottom: var(--space-4);">Taxes and shipping calculated at checkout</p>
      </div>
    `;

    body.innerHTML = html + subtotal;

    // Remove item handlers
    $$('[data-remove]', body).forEach(btn => {
      btn.addEventListener('click', () => {
        removeCartItem(btn.dataset.remove);
      });
    });
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(r => r.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      renderCartDrawerItems(cart);
    })
    .catch(console.error);
  }

  // Insert a Shopify CDN size suffix before the file extension, preserving any ?v= query string.
  function sizedImage(url, size) {
    if (!url) return url;
    return url.replace(/(\.(?:jpe?g|png|webp|gif|avif))(\?.*)?$/i, size + '$1$2');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
    }).format(cents / 100);
  }

  window.refreshCart = refreshCart;

  /* ── Add to cart ── */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    const origText = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    .then(r => r.json())
    .then(() => {
      refreshCart();
      openCart();
      if (btn) {
        btn.textContent = 'Added';
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = origText;
        }, 2000);
      }
    })
    .catch(() => {
      if (btn) {
        btn.disabled = false;
        btn.textContent = origText;
      }
    });
  });

  // Initial cart count on load
  refreshCart();

  /* ────────────────────────────────────────────
     PRODUCT GALLERY
  ──────────────────────────────────────────── */
  const gallery = $('.product-gallery');
  if (gallery) {
    const mainImg   = $('.product-gallery__main img', gallery);
    const thumbs    = $$('.product-gallery__thumb', gallery);

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImg) {
          const thumbImg = thumb.querySelector('img');
          const full = thumb.dataset.full || (thumbImg && thumbImg.src);
          if (full) {
            mainImg.src = full;
            mainImg.removeAttribute('srcset');
          }
        }
      });
    });
  }

  /* ────────────────────────────────────────────
     ACCORDIONS
  ──────────────────────────────────────────── */
  $$('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const isOpen = item.classList.contains('is-open');

      // Close all
      $$('.accordion__item').forEach(i => i.classList.remove('is-open'));

      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* ────────────────────────────────────────────
     QUANTITY SELECTOR
  ──────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const input = btn.closest('.qty-selector')?.querySelector('.qty-input');
    if (!input) return;

    let val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'decrease') val = Math.max(1, val - 1);
    if (btn.dataset.action === 'increase') val = Math.min(99, val + 1);
    input.value = val;
  });

  /* ────────────────────────────────────────────
     ANNOUNCEMENT BAR DISMISS
  ──────────────────────────────────────────── */
  const announcementDismiss = $('.announcement-bar__dismiss');
  if (announcementDismiss) {
    announcementDismiss.addEventListener('click', () => {
      const bar = announcementDismiss.closest('.announcement-bar');
      if (bar) bar.remove();
      sessionStorage.setItem('ot_announcement_dismissed', '1');
    });
    // Respect previous dismissal
    if (sessionStorage.getItem('ot_announcement_dismissed')) {
      const bar = announcementDismiss.closest('.announcement-bar');
      if (bar) bar.remove();
    }
  }

  /* ────────────────────────────────────────────
     SMOOTH INTERSECTION REVEAL
  ──────────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    $$('.animate-fade-up').forEach(el => {
      el.style.animationPlayState = 'paused';
      revealObserver.observe(el);
    });
  }

  /* ────────────────────────────────────────────
     NEWSLETTER FORM
  ──────────────────────────────────────────── */
  $$('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]')?.value;
      const btn   = form.querySelector('button[type="submit"]');

      if (!email) return;

      if (btn) {
        btn.disabled = true;
        btn.textContent = '…';
      }

      // Shopify newsletter subscribe
      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'customer',
          'customer[email]': email,
          contact: ''
        })
      }).finally(() => {
        const msg = document.createElement('p');
        msg.textContent = 'Thank you — stay tuned.';
        msg.style.cssText = 'font-family: var(--font-display); font-style: italic; font-size: 0.9375rem; color: rgba(255,255,255,0.7); margin-top: 8px;';
        form.replaceWith(msg);
      });
    });
  });

})();
